import { formatCnpj, isValidCnpj, stripCnpjMask } from './cnpj';
import { formatCpf, isValidCpf, stripCpfMask } from './cpf';
import { CNPJ_LENGTH, CPF_LENGTH } from './constants';

export type BrazilianDocumentType = 'cpf' | 'cnpj' | 'unknown';

export function stripDocumentMask(value: string): string {
  if (!value) {
    return '';
  }

  const normalized = value.toUpperCase().replace(/[.\-/]/g, '');

  if (/[A-Z]/.test(normalized) || normalized.length > CPF_LENGTH) {
    return stripCnpjMask(value);
  }

  return stripCpfMask(value);
}

export function detectDocumentType(value: string): BrazilianDocumentType {
  const stripped = stripDocumentMask(value);

  if (!stripped) {
    return 'unknown';
  }

  if (/[A-Z]/.test(stripped) || stripped.length > CPF_LENGTH) {
    return 'cnpj';
  }

  if (stripped.length <= CPF_LENGTH) {
    return 'cpf';
  }

  return 'unknown';
}

export function isValidCpfCnpj(value: string): boolean {
  const documentType = detectDocumentType(value);

  if (documentType === 'cpf') {
    return isValidCpf(value);
  }

  if (documentType === 'cnpj') {
    return isValidCnpj(value);
  }

  return false;
}

export function formatCpfCnpj(value: string): string {
  if (!value) {
    return '';
  }

  const documentType = detectDocumentType(value);

  if (documentType === 'cpf') {
    return formatCpf(value);
  }

  if (documentType === 'cnpj') {
    return formatCnpj(value);
  }

  return value;
}

export function isCompleteDocument(value: string): boolean {
  const stripped = stripDocumentMask(value);
  return stripped.length === CPF_LENGTH || stripped.length === CNPJ_LENGTH;
}
